import React from 'react'
import { Helmet } from 'react-helmet'
import { GA_MEASUREMENT_IDS, GTM_CONTAINER_ID } from '../../utils/googleAnalytics'

/**
 * CRA용 Google Analytics 4(gtag) + Google Tag Manager 스니펫.
 * ID는 REACT_APP_GA_MEASUREMENT_ID, REACT_APP_GTM_ID 환경 변수로 설정.
 */
export default function GoogleTags() {
    const gaIds = GA_MEASUREMENT_IDS
    const primaryGaId = gaIds[0]
    const gtmId = GTM_CONTAINER_ID

    const gtagInitScript =
        gaIds.length > 0
            ? [
                  'window.dataLayer = window.dataLayer || [];',
                  'function gtag(){dataLayer.push(arguments);}',
                  'gtag("js", new Date());',
                  ...gaIds.map((id) => `gtag("config", "${id}");`),
              ].join('\n')
            : 'window.dataLayer = window.dataLayer || [];'

    return (
        <>
            <Helmet>
                <script>{gtagInitScript}</script>
            </Helmet>

            {gtmId ? (
                <Helmet>
                    <script>{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');`}</script>
                </Helmet>
            ) : null}

            {gtmId ? (
                <Helmet>
                    <noscript>{`<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`}</noscript>
                </Helmet>
            ) : null}

            {primaryGaId ? (
                <Helmet>
                    <script async src={`https://www.googletagmanager.com/gtag/js?id=${primaryGaId}`} />
                </Helmet>
            ) : null}
        </>
    )
}
